import { Flex, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import CloseIcon from '@components/icons/CloseIcon';
import Button from '@components/interactive/Button';
import Header from '@components/typography/Header';
import { antlerStyle } from '@constants/styles';
import { useRouter } from 'next/router';

const CallUsModal = ({ isOpen, onClose }) => {
  const router = useRouter();

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent
        borderRadius={0}
        background="white"
        border={antlerStyle.border}
        borderColor="red.400 !important"
        id="exit_intent_modal"
        maxWidth="600px"
        paddingY={4}
      >
        <ModalHeader>
          <Flex justifyContent="space-between">
            <Header as="h1">Talk to an agent</Header>
            <CloseIcon onClick={onClose} />
          </Flex>
        </ModalHeader>
        <ModalBody>
          <Text textStyle="wizardText">To reshop in a new zip code, please make an appointment with an FSM agent.</Text>
        </ModalBody>
        <ModalFooter justifyContent="center">
          <Button
            colorScheme="blue"
            onClick={() => {
              router.push('/account/call-us?context=aep');
              onClose();
            }}
          >
            Make Appointment
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CallUsModal;
